import { render } from "./AppPostListText.html?vue&type=template&id=b314dbda"
import script from "./AppPostListText.js?vue&type=script&lang=js"
export * from "./AppPostListText.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__